import React from 'react'
import PropTypes from 'prop-types'

import FlatButton from 'material-ui/FlatButton'
import DownArrow from 'material-ui/svg-icons/hardware/keyboard-arrow-down'
import Popover from 'material-ui/Popover'
import Toggle from 'material-ui/Toggle'

export default class SettingsButton extends React.Component {

  static defaultProps = {
    hideEmptyRows: true
  }

  static propTypes = {
    hideEmptyRows: PropTypes.bool,
    onSettingsChange: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      hideEmptyRows: props.hideEmptyRows,
      openMenu: false
    }
  }

  componentWillMount() {
    this.props.onSettingsChange({ hideEmptyRows: this.state.hideEmptyRows })
  }

  render() {
    return (
      <div
        ref={root => this.root = root}
        style={{ marginLeft: 16, backgroundColor: '#fafafa' }}>
        <FlatButton
          style={{ width: 112, border: '1px solid #dbdee1' }}
          onTouchTap={() => this.setState({ openMenu: true })}>
          <div
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span
              style={{
                textTransform: 'none',
                fontSize: 14
              }}>
              Settings
            </span>
            <DownArrow />
          </div>
        </FlatButton>

        <Popover
          open={this.state.openMenu}
          anchorEl={this.root}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onRequestClose={() => this.setState({ openMenu: false })}>

          <div
            style={{ margin: 20 }}>
            <span
              style={{ fontSize: 14, color: '#a7abaf' }}>
              SETTINGS
            </span>

            <Toggle
              style={{ marginTop: 20 }}
              labelStyle={{ fontSize: 14, marginRight: 32 }}
              label="Hide empty rows & columns"
              toggled={this.state.hideEmptyRows}
              onToggle={(event, isInputChecked) => {
                this.setState({ hideEmptyRows: isInputChecked })
                this.props.onSettingsChange({ hideEmptyRows: isInputChecked })
              }}/>
          </div>
        </Popover>
      </div>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/reports/common/SettingsButton.js